import { render, staticRenderFns } from "./UserDetails_Section_Header.vue?vue&type=template&id=2a3100e5&scoped=true&"
import script from "./UserDetails_Section_Header.vue?vue&type=script&lang=js&"
export * from "./UserDetails_Section_Header.vue?vue&type=script&lang=js&"
import style0 from "./UserDetails_Section_Header.vue?vue&type=style&index=0&id=2a3100e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3100e5",
  null
  
)

export default component.exports